import { faFrown } from '@fortawesome/pro-solid-svg-icons';
import { Session } from '@shared/app/scripts/services/session';
import { User } from '@core/app/scripts/services/user';

/**
 * # EmailVerificationCtrl
 * Controller of the gateApp
 * User will verify his email and will be prompted for redirection to landing on success
 * Or an error will be shown that the verification failed or is expired and will have a redirect
 * to home state button shown.
 *
 * Email and key are inferred from the query params in the url.
 */
angular.module('gateApp').component('emailVerification', {
  template: require('./email-verification.html').default,
  controller: function (
    $routeParams: ng.route.IRouteParamsService,
    $location: ng.ILocationService,
    $translate: ng.translate.ITranslateService,
    user: User,
    session: Session,
  ) {
    const $ctrl = this;

    $ctrl.faFrown = faFrown;

    user
      .verifyEmail($routeParams.email, $routeParams.key)
      .then(() => {
        $ctrl.isVerified = true;
        $ctrl.message = $translate.instant('gate.verified_email', {
          email: $routeParams.email,
        });
        session.init();
      })
      .catch((message) => {
        $ctrl.message = message;
        $ctrl.isError = true;
      });

    $ctrl.redirectTo = (url) => $location.url(url);
  },
});
